/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Material_RemoveInputs */

const vi_pll_new_material_remove = /** @type {(inputs: Pll_New_Material_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá dòng vật tư`)
};

/**

* @param {Pll_New_Material_RemoveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_material_remove = /** @type {((inputs?: Pll_New_Material_RemoveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Material_RemoveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_material_remove(inputs)
});